export function formatDate(dateStr) {
  const dateObj = new Date(dateStr);
  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };
  return dateObj.toLocaleDateString('en', options);
}

export function formatRecurlyPlanInterval(interval, intervalLength) {
  const strInterval = String(interval);
  const strIntervalLength = String(intervalLength);
  var formattedInterval = 'per ' + strIntervalLength + ' ' + strInterval;
  if (strInterval === 'months') {
    if (strIntervalLength === '1') {
      formattedInterval = 'per month';
    } else if (strIntervalLength === '12') {
      formattedInterval = 'per year';
    } else {
      formattedInterval = 'per ' + strIntervalLength + ' months';
    }
  }
  return formattedInterval;
}

export function formatRecurlyPrice(price, currencyCode) {
  var formattedPrice;
  try {
    formattedPrice = Number(price).toFixed(2);
  } catch (err) {
    console.error(err);
    formattedPrice = price;
  }
  var returnPrice = formattedPrice + ' ' + currencyCode;
  if (currencyCode === 'USD') {
    returnPrice = '$' + formattedPrice + ' USD';
  }
  return returnPrice;
}
